import script from "./ExpiredRecruitment.component.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpiredRecruitment.component.vue?vue&type=script&setup=true&lang=js"

import "./ExpiredRecruitment.component.vue?vue&type=style&index=0&id=64b44ec0&lang=scss"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
